var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeritCircleInvestment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 400.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\r\n\t.st4{fill:#EF9146;}\r\n\t.st5{fill:#E57622;}\r\n\t.st6{fill:#05070C;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.8414,
    y1: 300.476,
    x2: 165.6587,
    y2: 210.321,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9146"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0592E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.98,351.92c29.58,0,53.61-23.74,54.09-53.2l0.01-0.89c0,49.79-40.36,90.15-90.15,90.15 c-49.79,0-90.15-40.36-90.15-90.15h72.12C144.88,327.71,169.1,351.92,198.98,351.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9457,
    y1: 298.9005,
    x2: 162.9457,
    y2: 208.7455,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57722"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2B24C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.88,351.92c-29.58,0-53.61-23.74-54.09-53.2l-0.01-0.89c0,49.79,40.36,90.15,90.15,90.15 c49.79,0,90.15-40.36,90.15-90.15h-72.12C180.98,327.7,156.76,351.92,126.88,351.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9457,
    y1: 298.9005,
    x2: 162.9457,
    y2: 392.8824,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57722"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD4A33"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.88,243.73c-29.58,0-53.61,23.74-54.09,53.2l-0.01,0.89c0-49.79,40.36-90.15,90.15-90.15 c49.79,0,90.15,40.36,90.15,90.15h-72.12C180.98,267.95,156.76,243.73,126.88,243.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9133,
    y1: 298.8976,
    x2: 162.9133,
    y2: 389.0523,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3C44F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.98,243.73c29.58,0,53.61,23.74,54.09,53.2l0.01,0.89c0-49.79-40.36-90.15-90.15-90.15 c-49.79,0-90.15,40.36-90.15,90.15h72.12C144.88,267.95,169.1,243.73,198.98,243.73z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.99,296.92H73.67v1.8h70.32V296.92z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.2,296.92h-70.32v1.8h70.32V296.92z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.62,295.91l0.45-59.77c0-0.2,0.05-0.36,0.15-0.49c0.1-0.16,0.22-0.25,0.35-0.25c0.33,0,0.55,0.16,0.65,0.49 l15.25,53.25c0.6,2.06,1.72,3.69,3.36,4.9c1.64,1.21,3.56,1.81,5.77,1.81h0.4c2.17,0,4.1-0.6,5.77-1.81 c1.67-1.24,2.79-2.89,3.36-4.95l14.99-53.2c0.1-0.33,0.33-0.49,0.7-0.49c0.13,0,0.25,0.08,0.35,0.25c0.1,0.13,0.15,0.29,0.15,0.49 v59.77h9.28v-60.75c0-1.9-0.35-3.6-1.05-5.1c-0.7-1.54-1.69-2.73-2.96-3.58c-1.24-0.88-2.62-1.32-4.16-1.32h-1.1 c-2.17,0-4.08,0.6-5.72,1.81c-1.6,1.18-2.71,2.78-3.31,4.8l-15.95,53.49c-0.1,0.33-0.32,0.49-0.65,0.49c-0.37,0-0.6-0.16-0.7-0.49 l-15.4-53.35c-0.6-2.09-1.74-3.74-3.41-4.95c-1.64-1.21-3.54-1.81-5.72-1.81c-1.81,0-3.43,0.42-4.86,1.27s-2.57,2.03-3.41,3.53 c-0.84,1.47-1.25,3.15-1.25,5.05l-0.6,60.9H316.62z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M424.48,265.9c0-3.33-1.17-6.39-3.51-9.17c-2.34-2.75-5.7-4.12-10.08-4.12c-4.35,0-7.77,1.49-10.28,4.46 c-2.47,2.97-3.71,5.92-3.71,8.83v0.49h27.58V265.9z M434.66,270.51c-0.03,0.75-0.05,1.32-0.05,1.72c0,0.36,0,0.92,0,1.67H396.9v0.54 c0,3.79,1.27,7.06,3.81,9.81c2.54,2.75,5.9,4.12,10.08,4.12c6.32,0,10.68-2.34,13.09-7.01h9.68c-1.27,4.9-3.98,8.73-8.12,11.47 c-4.15,2.75-9.03,4.1-14.64,4.07c-7.22,0-12.99-2.42-17.3-7.26c-4.31-4.84-6.47-11.24-6.47-19.22c0-7.98,2.09-14.35,6.27-19.12 c4.21-4.77,10.06-7.16,17.55-7.16c7.49,0,13.34,2.39,17.55,7.16C432.57,256.13,434.66,262.54,434.66,270.51z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M441.41,295.91h9.43v-29.17c0-3.56,1.29-6.73,3.86-9.51c2.51-2.78,6.15-4.17,10.93-4.17h1.55 c0.27,0.03,0.79,0.11,1.55,0.25v-8.97l-2.11-0.25l-0.9-0.05c-3.71,0-7.02,1.23-9.93,3.68c-2.88,2.45-4.68,4.53-5.42,6.23h-0.85 l0.85-8.73h-8.98V295.91z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M483.39,295.91h-9.28v-50.8h9.28V295.91z M472.65,231.04c0-1.6,0.59-2.97,1.76-4.12 c1.2-1.14,2.62-1.72,4.26-1.72c1.64,0,3.04,0.57,4.21,1.72c1.17,1.14,1.76,2.52,1.76,4.12c0,1.6-0.59,2.99-1.76,4.17 c-1.17,1.14-2.57,1.72-4.21,1.72c-1.64,0-3.06-0.57-4.26-1.72C473.24,234.03,472.65,232.65,472.65,231.04z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.25,230.55h-9.03v6.82v7.75H487.8v7.5h9.63v28.98c0,4.58,1.25,8.12,3.76,10.64 c2.51,2.45,5.92,3.68,10.23,3.68c1.67,0,3.11-0.15,4.31-0.44c1.27-0.2,2.07-0.36,2.41-0.49v-8.38c-0.33,0.13-0.94,0.25-1.81,0.34 c-1,0.07-1.69,0.1-2.06,0.1c-2.57,0-4.4-0.56-5.47-1.67c-1.04-1.14-1.55-2.89-1.55-5.25v-27.51h10.88v-7.5h-10.88V230.55z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M599.33,273.8c0,4.02-2.12,8.76-6.37,14.22c-2.11,2.52-5.06,4.63-8.88,6.32c-3.81,1.7-8.12,2.55-12.94,2.55 c-10.43,0-18.19-3.27-23.27-9.81c-5.08-6.54-7.62-15.3-7.62-26.28c0-11.05,2.74-19.91,8.22-26.57c5.52-6.67,13.07-10,22.67-10 c4.95,0,9.38,0.9,13.29,2.7c3.95,1.8,6.9,3.99,8.88,6.57c4.08,5.65,6.08,10.26,6.02,13.83h-9.78c-3.21-9.38-9.34-14.24-18.41-14.56 c-6.79,0-12,2.45-15.65,7.35c-3.61,4.9-5.43,11.72-5.47,20.45c0,8.76,1.82,15.59,5.47,20.49c3.68,4.9,8.89,7.34,15.65,7.31 c5.22,0,9.31-1.52,12.29-4.56c3.01-3.07,5.05-6.41,6.12-10H599.33z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M615.15,295.91h-9.28v-50.8h9.28V295.91z M604.42,231.04c0-1.6,0.59-2.97,1.76-4.12 c1.2-1.14,2.62-1.72,4.26-1.72c1.64,0,3.04,0.57,4.21,1.72c1.17,1.14,1.76,2.52,1.76,4.12c0,1.6-0.59,2.99-1.76,4.17 c-1.17,1.14-2.57,1.72-4.21,1.72c-1.64,0-3.06-0.57-4.26-1.72C605,234.03,604.42,232.65,604.42,231.04z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M623.92,295.91h9.43v-29.17c0-3.56,1.29-6.73,3.86-9.51c2.51-2.78,6.15-4.17,10.93-4.17h1.55 c0.27,0.03,0.79,0.11,1.55,0.25v-8.97l-2.11-0.25l-0.9-0.05c-3.71,0-7.02,1.23-9.93,3.68c-2.87,2.45-4.68,4.53-5.42,6.23h-0.85 l0.85-8.73h-8.98V295.91z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M689.22,262.28c-2.21-6.08-6.7-9.3-13.49-9.66c-4.55-0.03-8.16,1.62-10.83,4.95 c-2.68,3.33-4.01,7.65-4.01,12.94c0,5.3,1.34,9.59,4.01,12.9c2.67,3.3,6.28,4.95,10.83,4.95c6.79-0.33,11.28-3.53,13.49-9.61H699 c-1.37,5.62-4.06,10.05-8.08,13.29c-4.01,3.24-9.08,4.85-15.19,4.85c-7.59,0-13.53-2.4-17.8-7.21c-4.25-4.8-6.37-11.21-6.37-19.22 c0-8.01,2.12-14.4,6.37-19.17c4.28-4.77,10.21-7.17,17.8-7.21c6.19,0,11.28,1.63,15.3,4.9c4.01,3.27,6.67,7.7,7.97,13.29H689.22z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M715.13,295.91h-9.28v-70.7h9.28V295.91z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M759.82,265.9c0-3.33-1.17-6.39-3.51-9.17c-2.34-2.75-5.7-4.12-10.08-4.12c-4.35,0-7.77,1.49-10.28,4.46 c-2.48,2.97-3.71,5.92-3.71,8.83v0.49h27.58V265.9z M770,270.51c-0.03,0.75-0.05,1.32-0.05,1.72c0,0.36,0,0.92,0,1.67h-37.71v0.54 c0,3.79,1.27,7.06,3.81,9.81c2.54,2.75,5.9,4.12,10.08,4.12c6.32,0,10.68-2.34,13.09-7.01h9.68c-1.27,4.9-3.98,8.73-8.13,11.47 c-4.14,2.75-9.02,4.1-14.64,4.07c-7.22,0-12.99-2.42-17.3-7.26c-4.31-4.84-6.47-11.24-6.47-19.22c0-7.98,2.09-14.35,6.26-19.12 c4.21-4.77,10.07-7.16,17.55-7.16c7.49,0,13.34,2.39,17.55,7.16C767.91,256.13,770,262.54,770,270.51z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M307.07,374.29v-53.32h5.15v53.32H307.07z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M326.26,374.29v-38.02h5.07v5.91c1.36-2.22,3.16-3.96,5.38-5.23c2.27-1.26,4.9-1.89,7.88-1.89 c4.29,0,7.65,1.36,10.07,4.09c2.42,2.68,3.64,6.39,3.64,11.13v24.01h-5v-23.18c0-3.84-0.83-6.72-2.5-8.63 c-1.62-1.97-4.06-2.95-7.35-2.95c-2.37,0-4.47,0.61-6.29,1.82c-1.82,1.16-3.26,2.85-4.32,5.07c-1.01,2.22-1.51,4.82-1.51,7.8v20.07 H326.26z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.28,374.29l-15.22-38.02h5.3l12.57,31.89l12.5-31.89h5.3l-15.22,38.02H380.28z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M423.83,375.5c-3.79,0-7.09-0.86-9.92-2.58c-2.78-1.77-4.95-4.19-6.51-7.27c-1.51-3.08-2.27-6.59-2.27-10.53 c0-3.84,0.76-7.27,2.27-10.3c1.51-3.03,3.69-5.4,6.51-7.12c2.83-1.77,6.08-2.65,9.77-2.65c3.53,0,6.56,0.83,9.09,2.5 c2.58,1.62,4.54,3.89,5.91,6.82c1.36,2.93,2.05,6.29,2.05,10.07c0,0.66-0.03,1.21-0.08,1.67h-30.45c0.15,4.85,1.44,8.56,3.86,11.13 c2.42,2.58,5.68,3.86,9.77,3.86c2.88,0,5.25-0.66,7.12-1.97c1.87-1.31,3.61-3.21,5.23-5.68l3.79,2.35c-1.72,3.08-3.94,5.48-6.66,7.2 C430.62,374.66,427.46,375.5,423.83,375.5z M435.64,352.02c-0.1-3.94-1.26-7.02-3.48-9.24c-2.17-2.22-5-3.33-8.48-3.33 c-3.79,0-6.84,1.14-9.16,3.41c-2.27,2.22-3.66,5.28-4.17,9.16H435.64z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M463.76,375.5c-3.94,0-7.35-0.96-10.22-2.88c-2.88-1.97-4.97-4.62-6.29-7.95l4.39-2.05 c1.06,2.68,2.65,4.77,4.77,6.29c2.17,1.51,4.62,2.27,7.35,2.27c3.18,0,5.66-0.68,7.42-2.04c1.82-1.36,2.73-3.11,2.73-5.23 c0-1.72-0.56-3-1.67-3.86c-1.06-0.91-3.03-1.72-5.91-2.42c-0.5-0.1-1.04-0.23-1.59-0.38c-0.56-0.15-1.14-0.28-1.74-0.38 c-3.18-0.61-5.78-1.34-7.8-2.2c-1.97-0.86-3.48-1.97-4.54-3.33c-1.01-1.36-1.51-3.13-1.51-5.3c0-2.22,0.61-4.17,1.82-5.83 c1.21-1.67,2.88-2.93,5-3.79c2.17-0.91,4.62-1.36,7.35-1.36c3.69,0,6.66,0.83,8.94,2.5c2.32,1.67,4.17,3.91,5.53,6.74l-4.01,2.12 c-1.11-2.22-2.5-3.94-4.17-5.15c-1.67-1.26-3.76-1.89-6.29-1.89c-2.73,0-4.92,0.61-6.59,1.82c-1.67,1.21-2.5,2.75-2.5,4.62 c0,1.62,0.71,2.85,2.12,3.71c1.41,0.86,3.81,1.67,7.2,2.42c0.25,0.05,0.48,0.1,0.68,0.15c0.2,0.05,0.43,0.1,0.68,0.15 c3.38,0.66,6.06,1.41,8.03,2.27c2.02,0.86,3.53,2.02,4.54,3.48c1.06,1.46,1.59,3.38,1.59,5.76c0,2.22-0.63,4.24-1.89,6.06 c-1.21,1.77-2.98,3.16-5.3,4.17C469.6,374.99,466.89,375.5,463.76,375.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M499.51,374.74c-3.33,0-5.76-0.81-7.27-2.42c-1.51-1.67-2.27-3.94-2.27-6.82v-24.84h-6.44v-4.39h6.44v-9.54h5 v9.54h8.63v4.39h-8.63v24.61c0,1.82,0.43,3.1,1.29,3.86c0.91,0.76,2.37,1.14,4.39,1.14c0.81,0,1.79-0.08,2.95-0.23v4.24 C502.09,374.59,500.73,374.74,499.51,374.74z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M511.98,374.29v-38.1h5.07v5.3c1.11-2.02,2.63-3.58,4.54-4.7c1.92-1.16,4.12-1.74,6.59-1.74 c2.88,0,5.28,0.66,7.2,1.97c1.97,1.26,3.36,3.08,4.17,5.45c1.11-2.32,2.68-4.14,4.7-5.45c2.07-1.31,4.49-1.97,7.27-1.97 c3.84,0,6.82,1.06,8.94,3.18c2.12,2.12,3.18,5.3,3.18,9.54v26.51h-5.07v-25.37c0-3.18-0.68-5.53-2.04-7.04 c-1.36-1.57-3.38-2.35-6.06-2.35c-1.97,0-3.74,0.5-5.3,1.51c-1.51,0.96-2.7,2.37-3.56,4.24c-0.86,1.87-1.29,4.14-1.29,6.82v22.19h-5 v-25.37c0-3.18-0.68-5.53-2.04-7.04c-1.36-1.57-3.41-2.35-6.13-2.35c-1.97,0-3.71,0.5-5.23,1.51c-1.51,0.96-2.7,2.37-3.56,4.24 c-0.86,1.87-1.29,4.14-1.29,6.82v22.19H511.98z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M591.79,375.5c-3.79,0-7.09-0.86-9.92-2.58c-2.78-1.77-4.95-4.19-6.51-7.27c-1.51-3.08-2.27-6.59-2.27-10.53 c0-3.84,0.76-7.27,2.27-10.3c1.51-3.03,3.69-5.4,6.51-7.12c2.83-1.77,6.08-2.65,9.77-2.65c3.53,0,6.56,0.83,9.09,2.5 c2.58,1.62,4.54,3.89,5.91,6.82c1.36,2.93,2.05,6.29,2.05,10.07c0,0.66-0.03,1.21-0.08,1.67h-30.45c0.15,4.85,1.44,8.56,3.86,11.13 c2.42,2.58,5.68,3.86,9.77,3.86c2.88,0,5.25-0.66,7.12-1.97c1.87-1.31,3.61-3.21,5.23-5.68l3.79,2.35c-1.72,3.08-3.94,5.48-6.66,7.2 C598.58,374.66,595.43,375.5,591.79,375.5z M603.61,352.02c-0.1-3.94-1.26-7.02-3.48-9.24c-2.17-2.22-5-3.33-8.48-3.33 c-3.79,0-6.84,1.14-9.16,3.41c-2.27,2.22-3.66,5.28-4.17,9.16H603.61z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M618.86,374.29v-38.02h5.07v5.91c1.36-2.22,3.16-3.96,5.38-5.23c2.27-1.26,4.9-1.89,7.88-1.89 c4.29,0,7.65,1.36,10.07,4.09c2.42,2.68,3.64,6.39,3.64,11.13v24.01h-5v-23.18c0-3.84-0.83-6.72-2.5-8.63 c-1.62-1.97-4.06-2.95-7.35-2.95c-2.37,0-4.47,0.61-6.29,1.82c-1.82,1.16-3.26,2.85-4.32,5.07c-1.01,2.22-1.51,4.82-1.51,7.8v20.07 H618.86z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.7,374.74c-3.34,0-5.76-0.81-7.27-2.42c-1.51-1.67-2.27-3.94-2.27-6.82v-24.84h-6.44v-4.39h6.44v-9.54h5 v9.54h8.63v4.39h-8.63v24.61c0,1.82,0.43,3.1,1.28,3.86c0.91,0.76,2.38,1.14,4.39,1.14c0.81,0,1.8-0.08,2.96-0.23v4.24 C676.27,374.59,674.91,374.74,673.7,374.74z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M698.97,375.5c-3.94,0-7.34-0.96-10.23-2.88c-2.88-1.97-4.97-4.62-6.29-7.95l4.39-2.05 c1.06,2.68,2.66,4.77,4.78,6.29c2.17,1.51,4.62,2.27,7.34,2.27c3.18,0,5.65-0.68,7.42-2.04c1.82-1.36,2.73-3.11,2.73-5.23 c0-1.72-0.56-3-1.67-3.86c-1.06-0.91-3.03-1.72-5.91-2.42c-0.51-0.1-1.03-0.23-1.59-0.38c-0.55-0.15-1.13-0.28-1.74-0.38 c-3.18-0.61-5.78-1.34-7.8-2.2c-1.97-0.86-3.49-1.97-4.54-3.33c-1.01-1.36-1.52-3.13-1.52-5.3c0-2.22,0.6-4.17,1.82-5.83 c1.21-1.67,2.88-2.93,5-3.79c2.17-0.91,4.62-1.36,7.35-1.36c3.68,0,6.66,0.83,8.94,2.5c2.32,1.67,4.17,3.91,5.53,6.74l-4.01,2.12 c-1.12-2.22-2.5-3.94-4.17-5.15c-1.67-1.26-3.76-1.89-6.29-1.89c-2.73,0-4.93,0.61-6.59,1.82c-1.67,1.21-2.5,2.75-2.5,4.62 c0,1.62,0.71,2.85,2.12,3.71c1.42,0.86,3.82,1.67,7.2,2.42c0.25,0.05,0.48,0.1,0.68,0.15c0.2,0.05,0.43,0.1,0.68,0.15 c3.39,0.66,6.06,1.41,8.03,2.27c2.02,0.86,3.54,2.02,4.54,3.48c1.06,1.46,1.59,3.38,1.59,5.76c0,2.22-0.63,4.24-1.89,6.06 c-1.21,1.77-2.98,3.16-5.3,4.17C704.8,374.99,702.1,375.5,698.97,375.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.8414,
    y1: 300.476,
    x2: 165.6587,
    y2: 210.321,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9146"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0592E"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M198.98,351.92c29.58,0,53.61-23.74,54.09-53.2l0.01-0.89c0,49.79-40.36,90.15-90.15,90.15 c-49.79,0-90.15-40.36-90.15-90.15h72.12C144.88,327.71,169.1,351.92,198.98,351.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9457,
    y1: 298.9005,
    x2: 162.9457,
    y2: 208.7455,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57722"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2B24C"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M126.88,351.92c-29.58,0-53.61-23.74-54.09-53.2l-0.01-0.89c0,49.79,40.36,90.15,90.15,90.15 c49.79,0,90.15-40.36,90.15-90.15h-72.12C180.98,327.7,156.76,351.92,126.88,351.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9457,
    y1: 298.9005,
    x2: 162.9457,
    y2: 392.8824,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57722"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD4A33"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M126.88,243.73c-29.58,0-53.61,23.74-54.09,53.2l-0.01,0.89c0-49.79,40.36-90.15,90.15-90.15 c49.79,0,90.15,40.36,90.15,90.15h-72.12C180.98,267.95,156.76,243.73,126.88,243.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9133,
    y1: 298.8976,
    x2: 162.9133,
    y2: 389.0523,
    gradientTransform: "matrix(1 0 0 -1 3.051759e-05 596.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF9046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3C44F"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M198.98,243.73c29.58,0,53.61,23.74,54.09,53.2l0.01,0.89c0-49.79-40.36-90.15-90.15-90.15 c-49.79,0-90.15,40.36-90.15,90.15h72.12C144.88,267.95,169.1,243.73,198.98,243.73z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.99,296.92H73.67v1.8h70.32V296.92z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.2,296.92h-70.32v1.8h70.32V296.92z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeritCircleInvestment);
export default __webpack_public_path__ + "static/media/Merit Circle Investment.2ce7d7c8133bc1435402895bd1c0d3d0.svg";
export { ForwardRef as ReactComponent };